const { styled, Box } = require("@mui/material");

const BoxContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: theme.spacing(22.5),
  maxWidth: theme.spacing(31.25),
}));

export { BoxContainer };
